import axios from "./axios"

export const checkAuthToken = () => {

}

export const resendUserVerificationEmail = (token, userId) => {
	return axios.post("/auth0/resend-verification-email", {}, {
		headers: {
			"API-TOKEN": token,
		}
	})
}

export const checkUserVerificationStatus = (token) => {
	return axios.post("/auth0/check-email-verification", {}, {
		headers: {
			"API-TOKEN": token,
		}
	})
}

export const sendEmailOtp = (email, auth0UserId, name = "") => {
	return axios.post("/auth/send-email-otp", {
		email,
		auth0_user_id: auth0UserId,
		name,
	})
}

export const verifyEmailOtp = (email, otp, auth0UserId) => {
	return axios.post("/auth/verify-email-otp", {
		email,
		otp,
		auth0_user_id: auth0UserId,
	})
}

/** Checks whether an Auth0 user/claims sub belongs to an Intuit / QuickBooks connection. */
export const isIntuitConnection = (sub) => {
	if (!sub) return false;
	const s = String(sub).toLowerCase();
	return s.includes("quickbooks") || s.includes("intuit");
};

/**
 * Checks email verification status from claims and user object.
 * Returns true, false, or null (if not specified).
 */
export const isEmailVerifiedClaim = (claims, user) => {
	if (claims?.['https://app.wowbackupandrestore.com/email_verified'] === true || user?.['https://app.wowbackupandrestore.com/email_verified'] === true) return true;
	if (claims?.email_verified === true || claims?.emailVerified === true || claims?.email_verified === "true" || claims?.emailVerified === "true") return true;
	if (user?.email_verified === true || user?.emailVerified === true || user?.email_verified === "true" || user?.emailVerified === "true") return true;
	if (claims?.email_verified === false || claims?.emailVerified === false || claims?.email_verified === "false" || claims?.emailVerified === "false") return false;
	if (user?.email_verified === false || user?.emailVerified === false || user?.email_verified === "false" || user?.emailVerified === "false") return false;
	return null;
};

/**
 * Returns true if the authenticated identity is an Intuit account with an unverified email.
 */
export const isIntuitUnverified = (claims, user) => {
	const sub = claims?.sub || user?.sub;
	if (!isIntuitConnection(sub)) return false;
	const verified = isEmailVerifiedClaim(claims, user);
	return verified === false;
};

/** True when Auth0 `sub` is Google, Xero, or QuickBooks/Intuit (no email OTP on Complete Profile). */
export const isSocialAuth0Sub = (sub) => {
	if (!sub) return false;
	return getAuthenticationMethod({ sub: String(sub) }).isSocialLogin;
};

export const getAuthenticationMethod = (idToken) => {
	try {
		let payload;
		if (typeof idToken === "string") {
			payload = decodeJwtPayload(idToken);
		} else if (idToken && typeof idToken === "object" && "sub" in idToken) {
			payload = idToken;
		} else {
			return { isSocialLogin: false, provider: null, providerName: "Email" };
		}
		if (!payload || payload.sub == null) {
			return { isSocialLogin: false, provider: null, providerName: "Email" };
		}
		const sub = String(payload.sub);
		const parts = sub.split("|");
		const connection = (parts.length >= 3 && parts[0] === "oauth2") ? parts[1] : (parts[0] || null);
		const isIntuit = isIntuitConnection(sub);
		const isSocialLogin =
			isIntuit ||
			connection === "google-oauth2" ||
			connection === "oauth2" ||
			(connection && connection.startsWith("Xero-"));
		const providerName = isIntuit
			? "QuickBooks"
			: connection === "google-oauth2"
				? "Google"
				: connection === "oauth2" || (connection && connection.startsWith("Xero-"))
					? "Xero"
					: getConnectionDisplayName(connection);
		return { isSocialLogin, provider: connection, providerName };
	} catch (error) {
		return { isSocialLogin: false, provider: null, providerName: "Email" };
	}
};

function decodeJwtPayload(jwt) {
	const parts = String(jwt).split(".");
	if (parts.length < 2) return null;
	const base64url = parts[1];
	const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
	const pad = base64.length % 4;
	const padded = pad ? base64 + "=".repeat(4 - pad) : base64;
	try {
		return JSON.parse(atob(padded));
	} catch (e) {
		return null;
	}
}

function getConnectionDisplayName(connection) {
	const names = {
		'google-oauth2': 'Google',
		'oauth2': 'Xero',
		'quickbooks-online': 'QuickBooks',
		'intuit-openid': 'QuickBooks',
		'Username-Password-Authentication': 'Email'
	};
	return names[connection] || 'Unknown';
}
